// extracted by mini-css-extract-plugin
module.exports = {"container":"BestSchoolForm_container__3SWj3","date":"BestSchoolForm_date__G30k8","select":"BestSchoolForm_select__2Drsn","error":"BestSchoolForm_error__1v_04"};